import React from "react";
import { Container, Title, Description } from "./styles";

const SinistroApiError = () => {
  return (
    <Container>
      <Title variant="headline-06" align="left">
        Desculpe, estamos passando por alguma instabilidade.
      </Title>
      <Description variant="body01-lg" align="left">
       <p> Por favor, tente pelo nosso aplicativo ou entre em contato com a Central de Assistências Dia & Noite e
        Sinistros<br /> no 0800 722 2492, de segunda a sexta-feira, das 8h às 18h
        (exceto feriados nacionais).</p>
      </Description>
    </Container>
  );
};
export default SinistroApiError;
